<template>
	<tr :class="{ active }">
		<td>
			<div :class="iconClasses"><component :is="subType.icon" /></div>
			<span>{{ subType.label }}</span>
		</td>
		<td>
			<span>{{ name }}</span>
		</td>
		<td>
			<span>{{ created }}</span>
		</td>
		<td class="actions">
			<!-- Activate or deactivate -->
			<Action
				v-if="!archived"
				:title="active ? 'Deactivate' : 'Activate'"
				class="btn"
				:class="{ 'btn--active': active }"
				@click="activate"
				:disabled="updating"
			>
				<IconDeactivate v-if="active" />
				<IconActivate v-else />
			</Action>
			<!-- View -->
			<Action title="View" class="btn" @click="view">
				<IconView />
			</Action>
			<!-- Edit -->
			<Action title="Edit" class="btn" @click="edit">
				<IconEdit />
			</Action>
			<!-- Add submission -->
			<Action title="Add submission" class="btn" @click="add">
				<IconAdd />
			</Action>
			<!-- Archive -->
			<Action
				:title="archived ? 'Restore' : 'Archive'"
				class="btn"
				@click="archive"
			>
				<IconRestore v-if="archived" />
				<IconArchive v-else />
			</Action>
			<!-- Download -->
			<DownloadButton :id="id" />
		</td>
	</tr>
</template>

<script>
import IconActivate from 'mdi-vue/Star'
import IconDeactivate from 'mdi-vue/StarOutline'
import IconView from 'mdi-vue/Eye'
import IconEdit from 'mdi-vue/Pencil'
import IconAdd from 'mdi-vue/PlusBox'
import IconArchive from 'mdi-vue/Archive'
import IconRestore from 'mdi-vue/Undo'
import IconText from 'mdi-vue/MessageText'
import IconImage from 'mdi-vue/Image'
import IconDrawing from 'mdi-vue/Pencil'

import DownloadButton from '@/components/admin/DownloadButton'
import Action from '@/components/shared/Action'

import { enums } from 'protoswipe-shared'
const { CampaignType } = enums

const types = {
	[CampaignType.text]: {
		label: 'Text',
		icon: IconText
	},
	[CampaignType.image]: {
		label: 'Image',
		icon: IconImage
	},
	[CampaignType.drawing]: {
		label: 'Drawing',
		icon: IconDrawing
	}
}

export default {
	name: 'campaigns-table-row',
	props: {
		id: Number,
		name: String,
		type: String,
		created_at: String,
		active: Boolean,
		archived: Boolean,
		updating: Boolean
	},
	computed: {
		created() {
			return new Date(this.created_at).toLocaleDateString()
		},
		subType() {
			return types[this.type]
		},
		iconClasses() {
			return `icon icon--${this.type}`
		}
	},
	methods: {
		emittable(data = {}) {
			return { id: this.id, name: this.name, ...data }
		},
		activate() {
			const active = !this.active
			this.$emit('activate', this.emittable({ active }))
		},
		archive() {
			const archive = !this.archived
			this.$emit('archive', this.emittable({ archive }))
		},
		navigate(name) {
			const params = { id: this.id }
			this.$router.push({ name, params })
		},
		view() {
			this.navigate(this.active ? 'Current Campaign' : 'View Campaign')
		},
		edit() {
			this.navigate('Edit Campaign')
		},
		add() {
			this.navigate('Add Submission')
		}
	},
	components: {
		Action,
		DownloadButton,
		IconActivate,
		IconDeactivate,
		IconView,
		IconEdit,
		IconAdd,
		IconArchive,
		IconRestore
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';

.icon {
	@include square(1.5rem);
	margin-right: 0.5rem;
	&--text {
		color: $blue-73;
	}
	&--image {
		color: $orange-95;
	}
	&--drawing {
		color: $green-50;
	}
}

.btn {
	color: $black;
}

.download {
	@include circle-button(1.5rem);
}
</style>
